import HubTemplate from "../templates/HubTemplate";
import { PROCEDURE_CATEGORIES, PROCEDURE_ROUTES } from "../data/procedures";

// /procedures — top-level hub linking all category hubs.
export function ProceduresHub() {
  const items = PROCEDURE_CATEGORIES.map((c) => ({ to: `/${c.slug}`, title: c.title }));
  return (
    <HubTemplate
      eyebrow="Procedures"
      title="Plastic surgery procedures in Vietnam"
      intro="Explore the main procedure areas. Every procedure page explains what may be involved, who may be assessed, risks and realistic outcomes — with suitability confirmed only after an assessment by a licensed medical professional."
      path="/procedures"
      items={items}
    />
  );
}

// Category hub (Face / Nose / Breast / Body / Revision).
export function CategoryHub({ categorySlug }) {
  const cat = PROCEDURE_CATEGORIES.find((c) => c.slug === categorySlug);
  const routes = PROCEDURE_ROUTES[cat?.key] || [];
  const items = routes.length
    ? routes.map((r) => ({ to: `/${r.slug}`, title: r.title }))
    : cat.items.map((i) => ({ to: `/procedures`, title: i }));

  return (
    <HubTemplate
      eyebrow={`${cat.title} · Vietnam`}
      title={`${cat.title} surgery in Vietnam`}
      intro={`${cat.intro} Request a private case review to understand which options may be suitable for you.`}
      path={`/${cat.slug}`}
      breadcrumb={[{ name: "Procedures", to: "/procedures" }, { name: cat.title }]}
      items={items}
    />
  );
}
